import { connect } from 'react-redux';
//
import ComparePage from 'pages/compare/compare-page';
import { IStoreState } from 'store';
import { addDeal, evaluateDeals, shiftDealLeft, shiftDealRight, removeDeal } from 'store/deal-comparison/actions';
import { setForecastType } from 'store/deal-evaluation/actions';
import { IDealComparisonProps } from 'store/deal-comparison/types';
import { ELoadingType } from 'store/loading/types';
import { clearModalContent, setModalContent } from 'store/modal/actions';

const mapStateToProps = ({
  deals,
  dealComparison,
  dealEvaluation,
  loading,
  fieldOptions,
}: IStoreState): IDealComparisonProps => ({
  availableDeals: deals.data,
  dealsWithEvaluation: dealComparison.dealsWithEvaluation,
  selectedForecastType: dealEvaluation.selectedForecastType,
  selectedUnitType: dealEvaluation.selectedUnitType,
  loading: loading.loading === ELoadingType.SPINNER,
  availableProducts: fieldOptions.products,
  compareDealIds: dealComparison.compareDealIds,
});

const mapDispatchToProps = {
  addDeal,
  evaluateDeals,
  shiftDealLeft,
  shiftDealRight,
  removeDeal,
  setForecastType,
  clearModalContent,
  setModalContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComparePage);
